import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, KeyValues10, LocalService, Status, TriggeredEvent, Wrapper10 } from '../../../service/local.service';

@Component({
  selector: 'app-edit-startup-config',
  templateUrl: './edit-startup-config.component.html',
  styleUrls: ['./edit-startup-config.component.scss']
})
export class EditStartupConfigComponent implements OnInit {
  id: string = ''; parentId = ''; wrapper: Wrapper10; lstSectionConfigKeys: string[] = ["startup"]; types; isHidden = false; maxBodyHeight = 0;
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.parentId == '0')
      this.parentId = '';
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.StartUpType).subscribe(result => {
      this.types = result;
      if (this.id == '') {
        this.onGetNextOrderStartUp();
      }
      else {
        this.onGetStartup();
      }
    });
  }

  onGetNextOrderStartUp() {
    this.configurationManagementService.getNextOrderStartUp(this.parentId).subscribe(result => {
      this.wrapper = {
        content: { key: '', v1: this.parentId, v2: result.toString(), v3: '', v4: '', v5: '' } as KeyValues10
      } as Wrapper10;      
    });
  }

  onGetStartup() {
    this.configurationManagementService.getStartup(this.id).subscribe(result => {
      this.isHidden = result.content.v6 == '1';
      this.wrapper = result;      
    });
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.wrapper.content.v1 = this.parentId;
    this.wrapper.content.v6 = this.isHidden ? '1' : '0';
    this.configurationManagementService.saveStartup(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        this.wrapper.content.key = this.id == '' ? result.id : this.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }      
    });
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
